import React, {Component} from 'react';
import Dropzone from 'react-dropzone';
import Axios from 'axios';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

class NewItemModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
          modal: false,
          success: false,
          item: {
            itemImage: '',
            title: '',
            content: '',
            price: 0.00,
            quantity: 0
          }
        };
    
        this.toggle = this.toggle.bind(this);
      }
    
      toggle() {
        this.setState({
          modal: !this.state.modal
        });
      }

      handleDrop = files => {
        const uploaders = files.map(file => {
          const formData = new FormData();
          formData.append('file', file);
          formData.append('tags', `codeinfuse, medium, gist`);
          formData.append('upload_preset', 'fmpnolmy'); // Replace the preset name with your own
          formData.append('api_key', '733265229594682'); // Replace API key with your own Cloudinary key
          formData.append('timestamp', (Date.now() / 1000) | 0);
    
          return Axios
          
            .post('https://api.cloudinary.com/v1_1/dream-flowers-llc/image/upload', formData, {
              headers: { 'X-Requested-With': 'XMLHttpRequest' }
              
            })
            .then(response => {
                console.log(response);
              const data = response.data;
              const fileURL = data.secure_url;
              this.setState({ item: { ...this.state.item, itemImage: fileURL } });
            });
        });

        // Once all the files are uploaded
        Axios.all(uploaders).then(() => {
        // ... perform after upload is successful operation
            console.log('request finished', uploaders);
          });
        };

          handleChange = (type, field) => event => {
            const newState = Object.assign({}, this.state);
            newState[type][field] = event.target.value;
            this.setState(newState);
          };


          addNewItem = () => {
            const newItem = this.state['item'];
            const requestURL = 'http://localhost:5000/';
            Axios
              .post(requestURL, newItem, {
              })
              .then(response => {
                console.log(response);
                this.setState({
                  success: false,
                    item: {
                    itemImage: '',
                    title: '',
                    content: '',
                    price: 0.00,
                    quantity: 0
                  }
                });
        
                if (this.state.success) {
                  this.toggle();
                }
              })
              .catch(err => {
                this.setState({ success: false });
                console.warn(err);
              });
          };

    render() {
        return (
             <div>
             <button color="danger" onClick={this.toggle}>{this.props.buttonLabel}</button>
             <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
               <ModalHeader> <form> <input type= "text" name= "itemsname" value={this.state.item.title} onChange={this.handleChange('item', 'title')} placeholder="Enter items name here!" /></form></ModalHeader>
               <ModalBody>
                <p>
                <textarea
                  row="50"
                  cols="50"
                  placeholder="enter details of the post here!"
                  name="content"
                  value={this.state.item.content}
                  onChange={this.handleChange('item', 'content')}
                />
                </p>
                 {this.state.item.itemImage ? (
              <img
                src={this.state.item.itemImage}
                style={{ height: '25%', width: '25%', marginLeft: 'auto', marginRight: 'auto' }}
                alt=""
              />
            ) : (
              <Dropzone onDrop={this.handleDrop} multiple accept="image/*">
                <p>Click a picture to upload for your items</p>
              </Dropzone>
            )}
            <div>
               Quantity: <input type="quantity"  min="0"  max = "100" id="quantity" value={this.state.item.quantity} onChange= {this.handleChange("item", "quantity")} ></input>
            </div>
            <div>
               Price of item $: <input type="itemprice" step="0.01"  min="0" id="itemprice" value={this.state.item.price} onChange= {this.handleChange("item", "price")} ></input>
            </div>
               </ModalBody>
               <ModalFooter>
                 <button color="primary" onClick={this.addNewItem}>Submit</button>{' '}
                 <button color="secondary" onClick={this.toggle}>Cancel</button>
               </ModalFooter>
             </Modal>
           </div>
          );
    }
}

export default NewItemModal;
